class SpotlightPanels {
	constructor(spotlightPanelsRow) {
		this.row = spotlightPanelsRow;
		this.columnCount = this.detectColumnCount();
		this.columns = this.getColumns();
		this.mediaQuery = window.matchMedia('(max-width: 1024px)');
		this.init();
		this.handleBreakpointChange();
	}

	handleBreakpointChange() {
		this.mediaQuery.addEventListener('change', (e) => {
			if (e.matches) {
				// Mobile
				this.destroyLayout();
			} else {
				// Desktop
				this.init();
			}
		});
	}

	destroyLayout() {
		this.row.style.display = '';
		this.row.style.flexWrap = '';
		this.row.style.gap = '';
	
		this.columns.forEach((column) => {
			column.style.flex = '';
			column.style.marginLeft = '';
			column.style.marginRight = '';
			column.style.paddingLeft = '';
			column.style.paddingRight = '';
			column.style.width = '';
			column.style.maxWidth = '';
			column.style.transition = '';
			column.classList.remove('block-spotlight-panels__col--content-visible');
		});
	}

	detectColumnCount() {
		// Check for class indicators first
		if (this.row.classList.contains('block-spotlight-panels__row--1cols')) return 1;
		if (this.row.classList.contains('block-spotlight-panels__row--2cols')) return 2;
		if (this.row.classList.contains('block-spotlight-panels__row--3cols')) return 3;
		if (this.row.classList.contains('block-spotlight-panels__row--4cols')) return 4;

		// Fallback: count columns by checking for Foundation grid classes
		const colsMedium12 = this.row.querySelectorAll('.columns.medium-12').length;
		const colsMedium6 = this.row.querySelectorAll('.columns.medium-6').length;
		const colsMedium4 = this.row.querySelectorAll('.columns.medium-4').length;
		const colsMedium3 = this.row.querySelectorAll('.columns.medium-3').length;

		if (colsMedium12 === 1) return 1;
		if (colsMedium6 === 2) return 2;
		if (colsMedium4 === 3) return 3;
		if (colsMedium3 === 4) return 4;

		// Count all columns
		const allCols = this.row.querySelectorAll('.block-spotlight-panels__col').length;
		return allCols;
	}

	getColumns() {
		return this.row.querySelectorAll('.block-spotlight-panels__col');
	}

	init() {

		if (this.mediaQuery.matches) {
			return;
		}

		// Only apply to background-image style with 1-4 columns
		if (!this.row.classList.contains('block-spotlight-panels--style-background-image')) {
			return;
		}

		if (this.columnCount < 1 || this.columnCount > 4) {
			return;
		}

		if (this.columns.length !== this.columnCount) {
			return;
		}

		// For single column, just apply layout (no hover effect needed)
		if (this.columnCount === 1) {
			this.applyLayout(1);
			return;
		}

		// For 2-4 columns, apply layout and hover effects
		this.applyLayout(this.columnCount);
		this.setupHoverEffects();
	}

	applyLayout(count) {
		// Set row to flexbox with no gap
		this.row.style.display = 'flex';
		this.row.style.flexWrap = 'nowrap';
		this.row.style.gap = '0';

		// Calculate default width based on column count
		const defaultWidth = 100 / count;

		// Reset all columns to equal width
		this.columns.forEach((column) => {
			column.style.flex = `1 1 ${defaultWidth}%`;
			column.style.marginLeft = '0';
			column.style.marginRight = '0';
			column.style.paddingLeft = '0';
			column.style.paddingRight = '0';
			column.style.width = 'auto';
			column.style.maxWidth = 'none';
			column.style.transition = 'flex 300ms ease-in-out';
		});
	}

	setupHoverEffects() {
		this.columns.forEach((column) => {
			let hoverTimeout = null;

			column.addEventListener('mouseenter', () => {
				// Clear any pending timeout
				if (hoverTimeout) {
					clearTimeout(hoverTimeout);
					hoverTimeout = null;
				}

				// First, expand the column width
				this.onColumnHover(column);

				// After the flex transition completes (300ms), show the content
				hoverTimeout = setTimeout(() => {
					column.classList.add('block-spotlight-panels__col--content-visible');
					hoverTimeout = null;
				}, 300);
			});

			column.addEventListener('mouseleave', () => {
				// Clear any pending timeout
				if (hoverTimeout) {
					clearTimeout(hoverTimeout);
					hoverTimeout = null;
				}

				// Immediately hide the content to avoid reflow during collapse
				column.classList.remove('block-spotlight-panels__col--content-visible');

				// Reset the column width
				this.onColumnLeave();
			});
		});
	}

	onColumnHover(hoveredColumn) {
		const count = this.columnCount;
		
		// Different flex ratios for different column counts
		if (count === 2) {
			// 2 columns: 65% hovered, 35% other
			hoveredColumn.style.flex = '1.857 1 0%'; // 65/35 ratio
			this.columns.forEach((column) => {
				if (column !== hoveredColumn) {
					column.style.flex = '1 1 0%';
				}
			});
		} else if (count === 3) {
			// 3 columns: 50% hovered, 25% each for others (2:1:1 ratio)
			hoveredColumn.style.flex = '2 1 0%';
			this.columns.forEach((column) => {
				if (column !== hoveredColumn) {
					column.style.flex = '1 1 0%';
				}
			});
		} else if (count === 4) {
			// 4 columns: 40% hovered, 20% each for others (2:1:1:1 ratio)
			hoveredColumn.style.flex = '2 1 0%';
			this.columns.forEach((column) => {
				if (column !== hoveredColumn) {
					column.style.flex = '1 1 0%';
				}
			});
		}
	}

	onColumnLeave() {
		const count = this.columnCount;
		const defaultWidth = 100 / count;

		// Reset all columns to equal width
		this.columns.forEach((column) => {
			column.style.flex = `1 1 ${defaultWidth}%`;
		});
	}
}

export default SpotlightPanels;
